export * from './zeit-delete-request.interface';
export * from './zeit-delete-response.interface';
export * from './zeit-delete.shapes';
